<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Ventas x Cliente</strong>
          </div>
          <b-form>
            <b-form-group
              label="Fecha Desde"
              label-for="fechaDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaDesde" 
                v-model="fechaDesde" 
                :state="fechaDesdeValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaDesdeFeedback">
                {{ fechaDesdeInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Hasta"
              label-for="fechaHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaHasta" 
                v-model="fechaHasta" 
                :state="fechaHastaValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaHastaFeedback">
                {{ fechaHastaInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <!-- <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarCliente">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !cliente,
                                  'fa fa-remove': cliente  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="cliente"
                  :value="clienteNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group> -->
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment';

export default {
  name: 'ABM',
  components: {
    appMensaje: Mensaje
  },
  mixins: [
    msjModal
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      fechaDesdeValida: null,
      fechaDesdeInvalidaMsj: '',
      fechaHastaValida: null,
      fechaHastaInvalidaMsj: '',

      fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
      // cliente: null,

      labelCols: 2,
    }
  },
  // computed: {
  //   clienteNombre() {
  //     return this.cliente? this.cliente.nombre.trim() : '';
  //   },
  // },
  created() {
    
  },  
  methods: {
    validate() {
    },
    exportXls () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      // let clienteId = 0;
      // if (this.cliente) {
      //   clienteId = this.cliente.id;
      // }

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        // clienteId
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('ventas/getRptResumenClientes', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rptVentas = this.$store.getters['ventas/rptVentas'];

            if (rptVentas) {
              if (rptVentas.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              let resumen = rptVentas.map(cliente => ({
                ...cliente,
                montoNetoSinReembolsos: this.roundNumber(cliente.montoNeto - cliente.montoNetoReembolsos, 2)
              }))

              let title= 'Resumen de Ventas x Cliente';
              let fileName = 'ventas-resumen-clientes';
              let format = [
                { titulo: 'Cliente', nombre: 'cliente', formato: '' },
                { titulo: 'Monto Neto', nombre: 'montoNeto', formato: '' },
                { titulo: 'Neto s/Reembolsos', nombre: 'montoNetoSinReembolsos', formato: '' },
                { titulo: 'Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' }
              ];

              this.exportXLS(title, fileName, resumen, format);              

            } else {
              this.showModalMsj('No hay datos para exportar', null, null, 'light')
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    roundNumber(num, scale) {
        if(!("" + num).includes("e")) {
            return +(Math.round(num + "e+" + scale)  + "e-" + scale);
        } else {
            var arr = ("" + num).split("e");
            var sig = ""
            if(+arr[1] + scale > 0) {
            sig = "+";
            }
            return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
        }
    }    
    // seleccionarCliente() {
    //   if (this.cliente) {
    //     this.cliente = null;
    //   } else {
    //     this.$refs.searchClienteModal.show();
    //   }
    // },
    // clienteSeleccionado(item) {
    //   this.cliente = item;
    //   this.$refs.searchClienteModal.hide();
    // },
  },
}
</script>

<style>
</style>
